import { render, staticRenderFns } from "./zfb.vue?vue&type=template&id=8149e1ec&scoped=true"
import script from "./zfb.vue?vue&type=script&lang=js"
export * from "./zfb.vue?vue&type=script&lang=js"
import style0 from "./zfb.vue?vue&type=style&index=0&id=8149e1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8149e1ec",
  null
  
)

export default component.exports